import { Stack, Typography,Box ,Divider} from "@mui/material";
import CustomIcon from "../../../../components/customIcon";
import { useSnackbar } from "notistack";
export const AccInformation = () => {
    const { enqueueSnackbar } = useSnackbar();

    const copyText = (text) => {
        navigator.clipboard.writeText(text);
        enqueueSnackbar("Copied to clipboard.", { variant: "success" })
    }
    return (
        <Stack spacing={"10px"}>
            <Typography variant="body1" sx={{ fontWeight: 500 }}>Transfer Money to this bank account</Typography>
            <Box sx={{ borderRadius: 1, border: "1px solid #e1e1e1" }}>
                <Stack direction={"row"} px={3} py={1.5} justifyContent={"space-between"}>
                    <Typography variant="body2">Name: RealX Marketplace Pvt. Ltd.</Typography>
                    <Box onClick={() => copyText(`RealX Marketplace Pvt. Ltd.`)} sx={{ cursor: "pointer", }}>
                        <CustomIcon name="copy" />
                    </Box>
                </Stack>
                <Divider />
                <Stack direction={"row"} px={3} py={1.5} justifyContent={"space-between"}>
                    <Typography variant="body2">Account Number: 10114176799</Typography>
                    <Box onClick={() => copyText(`10114176799`)} sx={{ cursor: "pointer", }}>
                        <CustomIcon name="copy" />
                    </Box>
                </Stack>
                <Divider />
                <Stack direction={"row"} px={3} py={1.5} justifyContent={"space-between"}>
                    <Typography variant="body2">IFSC Code: IDFB0041359</Typography>
                    <Box onClick={() => copyText("IDFB0041359")} sx={{ cursor: "pointer", }}>
                        <CustomIcon name="copy" />
                    </Box>
                </Stack>
                <Divider />
                <Stack direction={"row"} px={3} py={1.5} justifyContent={"space-between"}>
                    <Typography variant="body2">Bank: IDFC First Bank</Typography>
                    <Box onClick={() => copyText("IDFC First Bank")} sx={{ cursor: "pointer", }}>
                        <CustomIcon name="copy" />
                    </Box>
                </Stack>
                <Divider />
                <Stack direction={"row"} px={3} py={1.5} justifyContent={"space-between"}>
                    <Typography variant="body2">Branch: Karve Nagar, Pune</Typography>
                    <Box onClick={() => copyText("Karve Nagar, Pune")} sx={{ cursor: "pointer", }}>
                        <CustomIcon name="copy" />
                    </Box>
                </Stack>
            </Box>
        </Stack>
    )
}